var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.currentStandard),function(s,sid){return _c('span',{key:sid},[_c('span',[_vm._v(_vm._s(s.name))]),(sid < _vm.currentStandard.length - 1)?_c('span',[_vm._v(" / ")]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }